import React from 'react';

import PushTargetsManagement from '../../components/Admin/PushTargetsManagement'

import MainBlockHeader from '../MainBlockHeader'
import MainBlockContainer from '../MainBlockContainer';
import { useTranslation } from 'react-i18next';

export default function PushTargetsPage() {
  const { t } = useTranslation();

  return (
    <>
      <MainBlockHeader header={t('admin.pushTargets.pageTitle')} >
      </MainBlockHeader>

      <MainBlockContainer>
        <PushTargetsManagement />
      </MainBlockContainer>
    </>
  );
}
